"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_MEMBERS = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.ALL_MEMBERS = (type) => graphql_tag_1.default `
  ${type} Members($appAddress: String!, $first: Int!, $skip: Int!) {
    members(where: {
      appAddress: $appAddress,
			active: true
    },first: $first, skip: $skip) {
			id
      twitterId
      justification
      active
			appAddress
    }
  }
`;
//# sourceMappingURL=index.js.map